/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to save recording: {error}" |
*
* @param {Audio_Recorder_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_save_failed = /** @type {((inputs: Audio_Recorder_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'enregistrement : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aufzeichnung konnte nicht gespeichert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare la registrazione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить запись: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo guardar la grabación: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`录制保存失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`録画を保存できませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्डिंग सहेजने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar a gravação: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save recording: ${i?.error}`)
});